<template>
  <div class="row">
    <div class="col-md-12 mt50 referencia">     

      <div v-if="loading">
        <div class="loading center"><img src="@/assets/img/loading.gif" alt=""></div>
      </div>      

      <template v-else>

        <div v-if="error" class="frm-error">{{ error_message }}</div>

        <template v-else>
          <div class="proyecto">

            <h4 class="title">{{ getAriadna }}</h4>
          
            <div v-if="articulos" class="row">
              <div class="col-sm-2 center">
                
                <h4>CDU</h4>
                <select v-model="cduSelected" @change="updatePageContent(actualPage, false, true)">
                  <option value="Todas">Todas</option>
                  <option v-for=" (value, key, index) in cdus " :value="value" :key="index">{{ value }}</option>
                </select>
              </div>
              <div :class=" (Math.round(articulos.porcentaje_pendientes) >= 100) ? 'col-sm-2 center completed' : 'col-sm-2 center' ">
                <h4>{{ $t('Pendientes') }}</h4>
                <div :class="'c100 p'+ Math.round(articulos.porcentaje_pendientes) +' center'">
                  <span>{{ Math.round(articulos.porcentaje_pendientes) }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br>
                <p class="center">
                  {{ $t('Ejemplares') }}: {{ articulos.ejemplares_pendientes }} 
                </p>
              </div>
              <div class="col-sm-2 center">
                <h4>{{ $t('En Proceso') }}</h4>
                <div :class="'c100 p'+ Math.round(articulos.porcentaje_enproceso) +' center'">
                  <span>{{ Math.round(articulos.porcentaje_enproceso) }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br>
                <p class="center">
                  {{ $t('Ejemplares') }}: {{ articulos.ejemplares_enproceso }} <br>
                  {{ $t('Importe') }}: {{ toCurrency(articulos.total_enproceso) }}
                </p>
              </div>
              <div class="col-sm-2 center">
                <h4>{{ $t('Incidencias') }}</h4>
                <div :class="'c100 p'+ Math.round(articulos.porcentaje_incidencias) +' center'">
                  <span>{{ Math.round(articulos.porcentaje_incidencias) }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br>
                <p class="center">
                  {{ $t('Ejemplares') }}: {{ articulos.ejemplares_incidencias }} <br>
                  <router-link 
                    v-if="sustituciones" 
                    :to="{ 
                      name: 'sustituciones-con-propuestas',
                      params: { idConsorcio: getIdConsorcio, referencia: getReferencia }
                    }" 
                    class="buy-link todo mt5 pl10 pr10"
                  >
                    <i class="fa fa-retweet mr5"></i> {{ $t('Sustituciones') }} <span class="pl5">( {{ sustitucionesPendientes }} )</span>
                  </router-link>                          
                </p>
              </div>
              <div class="col-sm-2 center">
                <h4>{{ $t('Albaranados') }}</h4>
                <div :class="'c100 p'+ Math.round(articulos.porcentaje_albaranados) +' center pedidos-albaranados'">
                  <span>{{ Math.round(articulos.porcentaje_albaranados) }}%</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br>
                <p class="center">
                  {{ $t('Ejemplares') }}: {{ articulos.ejemplares_albaranados }} <br>
                  {{ $t('Importe') }}: {{ toCurrency(articulos.total_albaranados) }} <br>
                  <span class="text-black">{{ $t('Precio medio') }}: {{ toCurrency(articuloPrecioMedio) }}</span>
                </p>
              </div>
              <div class="col-sm-2 center completed">
                <h4>{{ $t('Total') }}</h4>
                <div class="c100 p100 center">
                  <span>{{ articulos.total_ejemplares }}</span>
                  <div class="slice">
                    <div class="bar"></div>
                    <div class="fill"></div>
                  </div>
                </div>
                <br>
                <p class="center">
                  {{ $t('Total ejemplares') }}: {{ articulos.total_ejemplares }}                
                </p>
              </div>
              <!-- <div class="col-sm-1 center">
              </div> -->
            </div>
          </div>

          <div class="proyecto mt50">
            <div v-if="articulos" class="row pt10">
              <div class="col-md-8">
                <h4 class="title">CDU {{ cduSelected }}</h4> 
              </div>
              <div class="col-md-4">
                <div v-if="filteredArticulos" class="download-excel align-right mb10">
                  <a :href="getApiUrl + getLocale + '/' + articulos.enlace_excel" class="buy-link todo" target="_blank"><i class="fa fa-file-excel-o"></i> {{ $t('Guardar') }} EXCEL</a>
                </div>
              </div>
            </div>             

            <template v-if="filteredArticulos">
              <table  class="table table-hover"> 
                <thead> 
                  <tr> 
                    <th></th>
                    <th>#</th>
                    <th @click="sortBy('fecha')">{{ $t('Fecha') }} <i class="fa fa-sort"></i></th>
                    <th @click="sortBy('referencia')">{{ $t('Referencia') }} <i class="fa fa-sort"></i></th>
                    <th @click="sortBy('titulo')">{{ $t('Artículo') }} <i class="fa fa-sort"></i></th> 
                    <th @click="sortBy('autor')">{{ $t('Autor') }} <i class="fa fa-sort"></i></th>
                    <th @click="sortBy('codigo')">{{ $t('Código') }} <i class="fa fa-sort"></i></th> 
                    <th @click="sortBy('cdu')">{{ $t('CDU') }} <i class="fa fa-sort"></i></th>
                    <th @click="sortBy('cantidad')" width="36" class="align-right"><div class="rotate-90">{{ $t('Cantidad') }}</div> <i class="fa fa-sort"></i></th> 
                    <th @click="sortBy('pendientes')" width="36" class="align-right"><div class="rotate-90">{{ $t('Pendientes') }}</div> <i class="fa fa-sort"></i></th> 
                    <th @click="sortBy('enproceso')" width="36" class="align-right"><div class="rotate-90">{{ $t('En Proceso') }}</div> <i class="fa fa-sort"></i></th> 
                    <th @click="sortBy('incidencias')" width="36" class="align-right"><div class="rotate-90">{{ $t('Incidencias') }}</div> <i class="fa fa-sort"></i></th> 
                    <th @click="sortBy('albaranados')" width="36" class="align-right"><div class="rotate-90">{{ $t('Albaranados') }}</div> <i class="fa fa-sort"></i></th> 
                    <th width="60"></th>
                  </tr> 
                </thead> 
                <tbody> 
                  <tr v-for=" (item, index) in filteredArticulos " :key="index"> 
                    <td class="padding0"><span :class="'box '+item.tipo">{{ (item.tipo == 'incidencia') ? '?' : item.tipo.substring(0,1).toUpperCase() }}</span></td>
                    <th>{{ index + 1 }}</th>
                    <td>{{ item.fecha }}</td> 
                    <td>{{ item.referencia }}</td> 
                    <td>{{ item.titulo }}</td>
                    <td>{{ item.autor }}</td>
                    <td>{{ item.codigo }}</td>
                    <td>{{ item.cdu }}</td>
                    <td class="align-right">{{ item.cantidad }}</td>
                    <td class="align-right">{{ item.pendientes }}</td> 
                    <td class="align-right">{{ item.enproceso }}</td>
                    <td class="align-right"><span :title="item.incidencias_title">{{ item.incidencias }}</span></td>  
                    <td class="align-right">{{ item.albaranados }}</td>                     
                    <td>   
                      <template v-for=" (elm, index) in item.albaranes ">
                        <a :key="index"
                          v-if="elm.link" 
                          :href="getApiUrl + getLocale + '/' + elm.link + ( (getUserRole == 'badmin') ? ('&bibl=' + getActiveBiblioteca) : '')" 
                          :title=" elm.title "
                          class="ml5"
                          target="_blank"><i class="fa fa-file-pdf-o"></i>
                        </a>
                      </template>
                    </td>
                  </tr> 
                </tbody> 
              </table>

              <div class="row">
                <div class="col-md-12 paginacion">
                  <nav aria-label="Page navigation">
                    <ul class="pagination">
                      <li><button @click=" updatePageContent(actualPage-1) "><span aria-hidden="true"><i class="fa fa-angle-left"></i></span></button></li>
                      
                      <template v-if=" totalPages > 10 && actualPage > N+1 ">
                        <li><button @click=" updatePageContent(1) " >1</button></li>
                        <li><a @click.prevent>...</a></li>
                      </template>

                      <template v-if=" totalPages <= 10 ">
                        <li v-for=" (i, index) in totalPages" :key="index"><button @click=" updatePageContent(i) "  :class="[ i ==  actualPage ? 'actual-page' : '']">{{ i }}</button></li>
                      </template> 

                      <template v-else> 
                        <li v-for=" (i, index) in range()" :key="index"><button @click=" updatePageContent(i) "  :class="[ i ==  actualPage ? 'actual-page' : '']">{{ i }}</button></li>
                        <template v-if=" actualPage < totalPages - N ">
                          <li><a @click.prevent>...</a></li>
                          <li><button @click=" updatePageContent(totalPages) " >{{ totalPages }}</button></li>
                        </template>
                      </template>

                      <li><button @click=" updatePageContent(actualPage+1) "><span aria-hidden="true"><i class="fa fa-angle-right"></i></span></button></li>
                    </ul>
                  </nav>
                </div>
              </div>
            </template>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "Por pedido": "Por pedido",
      "Proyecto": "Proyecto",
      "Fecha": "Fecha",
      "Artículo": "Artículo",
      "Autor": "Autor",
      "Cantidad": "Cantidad",
      "Referencia": "Referencia",
      "Código": "Código",
      "CDU": "CDU",
      "Situación": "Situación",
      "Todos": "Todos",
      "Pendiente": "Pendiente",
      "Pendientes": "Pendientes",
      "En Tatarana": "En Tatarana",
      "Incidencia": "Incidencia",
      "Incidencias": "Incidencias",
      "Albaranados": "Albaranados",
      "En Proceso": "En Proceso",
      "Facturado": "Facturado",
      "Tiene que seleccionar un proyecto": "Tiene que seleccionar un proyecto",
      "Vaciar": "Vaciar",
      "Buscar": "Buscar",
      "Tiene que seleccionar una referencia": "Tiene que seleccionar una referencia",
      "Total": "Total",
      "Guardar": "Guardar",
      "Vaciar": "Vaciar",
      "Ejemplares": "Ejemplares",
      "Total ejemplares": "Total ejemplares",
      "Importe": "Importe",
      "Precio medio": "Precio medio",
      "Sustituciones": "Sustituciones"
    },
    "en": {
    },
    "ca": {
      "Por pedido": "Per comanda",
      "Proyecto": "Projecte",
      "Fecha": "Data",
      "Artículo": "Article",
      "Autor": "Autor",
      "Cantidad": "Quantitat",
      "Referencia": "Referència",
      "Código": "Codi",
      "CDU": "CDU",
      "Situación": "Situació",
      "Todos": "Tots",
      "Pendiente": "Pendent",
      "Pendientes": "Pendents",
      "En Tatarana": "A Tatarana",
      "Incidencia": "Incidència",
      "Incidencias": "Incidencies",
      "Albaranados": "Albaranats",
      "En Proceso": "En Procés",
      "Facturado": "Facturat",
      "Tiene que seleccionar un proyecto": "Ha de seleccionar un projecte",
      "Vaciar": "Vaciar",
      "Buscar": "Buscar",
      "Tiene que seleccionar una referencia": "Ha de seleccionar una referència",
      "Total": "Total",
      "Guardar": "Guardar",
      "Vaciar": "Buidar",
      "Ejemplares": "Exemplars",
      "Total ejemplares": "Total exemplars",
      "Importe": "Import",
      "Precio medio": "Preu mitjà",
      "Sustituciones": "Substitucions"
    }
  }
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';

  export default {
    data: () => {
      return{
        proyectos: [],
        error: false,
        error_message: '',
        loading: false,
        loading2: false,
        sortKey: '',
        sortOrders: { fecha: 1, referencia: 1, titulo: 1, autor: 1, codigo: 1, cdu: 1 , cantidad: 1, pendientes: 1, enproceso: 1, incidencias: 1, albaranados: 1 },
        proyectosReferencias: [],
        idConsorcio: false,
        nombreReferencia: false,
        articulos: '',
        actualPage: 1,
        resultsPerPage: 20,
        N: 4,
        totalPages: 0,
        min: 0,
        max: 0,
        rangeArray: [],
        cdus: [],
        cduSelected: 'Todas',
        sustituciones: 0,
        sustitucionesPendientes: 0
      }
    },
    created(){
      this.cargarDatos()
    },
    mounted(){
      window.scrollTo(0, 0)

    },
    computed:{
      ...mapGetters(['getLocale', 'getApiUrl', 'getIdConsorcio', 'getReferencia', 'getUserRole', 'getActiveBiblioteca']),
      filteredReferencias: function(){
        let idConsorcio = this.getIdConsorcio;
        if (this.idConsorcio > 0){ 
          return this.proyectosReferencias.referencias.filter( function(obj){ return obj.id_consorcio === idConsorcio; }, idConsorcio );
        }
      },
      filteredArticulos: function(){
        return this.articulos.articulos;
      },
      getAriadna: function(){
        let consorcio;
        let referencia;

        referencia = ( this.getReferencia == null ) ? ' > ' + this.$t('Todos') : ' > ' + this.getReferencia;        
        
        return this.articulos.nombre_consorcio + referencia;
      },
      articuloPrecioMedio(){
        return (parseFloat(this.articulos.total_albaranados) / parseFloat(this.articulos.ejemplares_albaranados))
      }
    },
    methods: {
      cargarDatos(){
        this.resetError();     

        let queryToSend = {};
        if( this.getIdConsorcio == 0 ){ 
          queryToSend['id_consorcio'] = this.getIdConsorcio;
        }else{ 
          queryToSend['id_consorcio'] = this.getIdConsorcio;
          queryToSend['referencia'] = this.getReferencia;
        }

        // INICIO CONSORCIOS
        if(this.getUserRole == 'badmin'){
          queryToSend['bibl'] = this.getActiveBiblioteca;
        }
        // FIN CONSORCIOS

        axios.get( this.getApiUrl + this.getLocale + '/misconsultas/pedido', { 
          params: queryToSend
        })
          .then( (respuesta) =>{ 
            this.articulos = respuesta.data.data;
            this.totalPages = Math.ceil(this.articulos.total_articulos / this.resultsPerPage);

            this.sustituciones = parseInt(respuesta.data.data.sustituciones)

            this.cdus = Array.isArray(respuesta.data.data.cdus) ? respuesta.data.data.cdus : []

            this.sustitucionesPendientes = respuesta.data.data.pendientes

            this.hideLoading();
            this.range();
          })
        .catch( (error) =>{ 
          this.articulos = '';
          this.hideLoading();
          this.error_message = error.response.data.msg;
          this.error = true;
        });
      },
      updatePageContent(page, sort, cduChange){
        let queryToSend = {};
        if( this.getIdConsorcio == 0 ){ 
          queryToSend['id_consorcio'] = this.getIdConsorcio;
        }else{ 
          queryToSend['id_consorcio'] = this.getIdConsorcio;
          queryToSend['referencia'] = this.getReferencia;
        }

        if( this.cduSelected != 'Todas' ){
          queryToSend['cdu'] = this.cduSelected
        }        

        // INICIO CONSORCIOS
        if(this.getUserRole == 'badmin'){
          queryToSend['bibl'] = this.getActiveBiblioteca;
        }
        // FIN CONSORCIOS

        //console.log(queryToSend['referencia']);

        if( (page != this.actualPage && page > 0 && page <= this.totalPages) || sort == true || cduChange == true){ 
          queryToSend['p'] = page; 

          if( this.sortKey ){ 
            let order = (this.sortOrders[this.sortKey] == 1) ? '-' : '+';
            queryToSend['orden'] = this.sortKey + order; 
          }

          this.showLoading2();

          axios.get( this.getApiUrl + this.getLocale + '/misconsultas/pedido', { 
            params: queryToSend
          })
            .then( (respuesta) =>{ 
              this.articulos = respuesta.data.data;
              this.totalPages = Math.ceil(this.articulos.total_articulos / this.resultsPerPage);
              this.actualPage = page;
              this.sustitucionesPendientes = respuesta.data.data.pendientes
              this.range();
              this.hideLoading2();
            })
          .catch( (error) =>{ 
            this.articulos = '';
            this.hideLoading2();
            this.error_message2 = error.response.data.msg;
            this.error2 = true;
          });
        }
      },
      range(){
        var j = 0;

        this.min = ( parseInt(this.actualPage) - this.N < 1) ? 1 : ( parseInt(this.actualPage) > parseInt(this.totalPages) - this.N ) ? parseInt(this.totalPages) - 2*this.N : parseInt(this.actualPage) - this.N;
        this.max = ( parseInt(this.actualPage) + this.N > parseInt(this.totalPages) ) ? parseInt(this.totalPages) : ( parseInt(this.actualPage) < this.N+1) ? 2*this.N+1 : parseInt(this.actualPage) + this.N; 
        this.rangeArray.length = 0;

        for(var i = this.min; i <= this.max; i++){
          this.rangeArray[j] = i;
          j++;
        }
        return this.rangeArray;
      },
      sortBy(key){
        this.sortKey = key;
        this.sortOrders[key] = this.sortOrders[key] * -1;
        this.updatePageContent(this.actualPage, true);
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
      showLoading2(){ this.loading2 = true; },
      hideLoading2(){ this.loading2 = false; },
      resetError(){
        this.error_message = '';
        this.error = false;
      },
    },
    watch:{
      actualPage: function() { this.range(); },
    }
  }
</script>
